import React from 'react';
type AvatarProps = {
  name: string;
  size?: number;
  className?: string;
};
// A small, fixed palette of on-brand tints for the initial avatars.
const PALETTE = ['#f15a24', '#3b4fe0', '#5b3bd9', '#2fa84f', '#d9a441'];
function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
function pickTint(name: string): string {
  let sum = 0;
  for (let i = 0; i < name.length; i++) sum += name.charCodeAt(i);
  return PALETTE[sum % PALETTE.length];
}
/**
 * Simple initials avatar — a solid tinted circle with the person's initials.
 * Deterministic color per name so the same person always gets the same tint.
 */
export function Avatar({
  name,
  size = 44,
  className
}: AvatarProps) {
  const tint = pickTint(name);
  return <span className={className} role="img" aria-label={name} style={{
    width: size,
    height: size,
    flex: 'none',
    borderRadius: '50%',
    background: tint,
    color: '#fff',
    display: 'grid',
    placeItems: 'center',
    fontFamily: "'Space Grotesk', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: size * 0.36,
    letterSpacing: '-0.02em',
    userSelect: 'none'
  }} data-id="element-13">
      {initials(name)}
    </span>;
}